module.exports = __webpack_public_path__ + "img/lt.c3aeac0d.svg";